import { useEffect } from 'react';

import { updatePageTitle } from 'utils/pageTitleManager';

export const usePageTitle = (): void => {
  useEffect(() => {
    // Atualiza o título inicial
    updatePageTitle();

    // Adiciona um listener para mudanças na URL
    const handleLocationChange = () => {
      updatePageTitle();
    };

    window.addEventListener('popstate', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);
};
